import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const CourseGoogleMap = withGoogleMap(({ defaultZoom, pos }) => (
    <GoogleMap
        defaultZoom={defaultZoom}
        defaultCenter={pos}
        defaultMapTypeId="satellite"
    >
        <Marker
            position={pos}
        />
    </GoogleMap>
));

CourseGoogleMap.propTypes = {
    defaultZoom: PropTypes.number.isRequired,
    pos: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
};

export default CourseGoogleMap;



// WEBPACK FOOTER //
// ./src/js/course/courseMap/CourseGoogleMap.jsx